import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-task-comm',
  templateUrl: './task-comm.component.html',
  styleUrls: ['./task-comm.component.css']
})
export class TaskCommComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
